import React from "react";
import { useReducedHomeMotion } from "../../hooks/useReducedHomeMotion";
import "./homeAmbient.css";

const DUST_COLORS = ["#f3efe8", "#f0a8a0", "#c4b5fd", "#99f6e4", "#d8cce8"] as const;

function mulberry32(seed: number) {
  return () => {
    let t = (seed += 0x6d2b79f5);
    t = Math.imul(t ^ (t >>> 15), t | 1);
    t ^= t + Math.imul(t ^ (t >>> 7), t | 61);
    return ((t ^ (t >>> 14)) >>> 0) / 4294967296;
  };
}

function buildDust(count: number) {
  const rand = mulberry32(42);
  return Array.from({ length: count }, (_, id) => ({
    id,
    x: rand() * 100,
    y: rand() * 100,
    size: 1 + rand() * 2,
    color: DUST_COLORS[Math.floor(rand() * DUST_COLORS.length)],
    twinkleDuration: 2.8 + rand() * 3.5,
    twinkleDelay: rand() * 4,
    opacityPeak: 0.22 + rand() * 0.38,
  }));
}

/** 36 partículas — suficiente densidad visual, ~50% menos nodos que antes */
const DUST = buildDust(36);

export const StellarDust: React.FC = () => {
  const reduced = useReducedHomeMotion();

  return (
    <div className="home-dust pointer-events-none fixed inset-0 z-[1] overflow-hidden" aria-hidden>
      {DUST.map((p) => (
        <span
          key={p.id}
          className="home-dust-particle"
          style={
            {
              "--x": `${p.x}%`,
              "--y": `${p.y}%`,
              "--size": `${p.size}px`,
              "--color": p.color,
              "--dur": `${p.twinkleDuration}s`,
              "--delay": `${p.twinkleDelay}s`,
              "--peak": p.opacityPeak,
              ...(reduced ? { opacity: p.opacityPeak * 0.35 } : {}),
            } as React.CSSProperties
          }
        />
      ))}
    </div>
  );
};

export default StellarDust;
